import {
  type GenerateStyle,
  genComponentStyleHook,
  type FullToken,
} from "antd/es/theme/internal";
import { carouselPrefixCls } from "@/base/components/carousel/Carousel.component";
import { THEME_PREFIX, ICON_PREFIX } from "@/base/constant";

const genStyle: GenerateStyle<FullToken<"Carousel">> = ({
  arrowBg,
  arrowSize,
}: any) => ({
  [`.${carouselPrefixCls}`]: {
    [`.${THEME_PREFIX}`]: {
      [`.slick-arrow`]: {
        color: `${arrowBg} !important`,

        [`&.${ICON_PREFIX}`]: {
          fontSize: `${arrowSize}px !important`,
          opacity: 1,
        },

        [`&:after`]: {
          display: `none !important`,
        },
      },
    },
  },
});

export const useCarouselStyle = genComponentStyleHook(
  ["Carousel", "cso"],
  (token) => {
    return [genStyle(token)];
  },
);
